module.exports = __webpack_public_path__ + "static/media/harmonhall.d4e1c181.svg";